import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import viewAuditChange from './viewAuditChange';

export default {
  attributeName: 'audit',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  fields: [
    {
      attributeName: 'uuid',
      label: 'Uuid',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      width: '8rem',
      helpText: 'Filter by UUID (partial match supported).',
      canOrder: true,
      canFilter: true,
      hidden: true,
    },
    {
      attributeName: 'date',
      label: 'Date',
      type: FormInputTypes.DATE,
      width: '8rem',
      helpText: 'Filter audit records by date.',
      canOrder: true,
      canFilter: true,
    },
    {
      attributeName: 'process',
      label: 'Process',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      width: '8rem',
      helpText: 'Filter by process name.',
      canOrder: true,
      canFilter: true,
    },
    {
      attributeName: 'action',
      label: 'Action',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      width: '8rem',
      helpText: 'Filter by action performed.',
      canOrder: true,
      canFilter: true,
    },
    {
      attributeName: 'email',
      label: 'Email',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      width: '8rem',
      helpText: 'Filter by user email (partial match supported).',
      canOrder: true,
      canFilter: true,
    },
    {
      attributeName: 'ip',
      label: 'Ip',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      width: '8rem',
      helpText: 'Filter by IP address (partial match supported).',
      canOrder: true,
      canFilter: true,
    },
    {
      attributeName: 'changes',
      label: 'Changes',
      type: FormInputTypes.AUDIT_CHANGES,
      helpText: 'View detailed changes for this audit record.',
      canEdit: false,
      canCreate: false,
      configFile: viewAuditChange,      
      canFilter: true,
      width: '10rem',
      classNameCell: 'text-start align-middle'
    },
  ],
};
